import React from 'react'

import './Header.scss'
import classy from 'shared/utils/classy'

export interface PageHeaderProps {
  children: React.ReactNode
  /**
   * @deprecated - please use noBottomPadding instead as it's more clear
   **/
  noPadding?: boolean

  noBottomPadding?: boolean
  showBorder?: boolean
  sidePadding?: boolean
  topPadding?: boolean
}

const PageHeader = React.memo(
  ({
    children,
    noPadding = false,
    noBottomPadding = false,
    showBorder = true,
    sidePadding = false,
    topPadding = false,
  }: PageHeaderProps) => {
    const shouldIncludeBottomPadding = !noBottomPadding && !noPadding

    return (
      <header
        className={classy(
          'PageHeader',
          shouldIncludeBottomPadding && 'PageHeader--bottom-padding',
          sidePadding && 'PageHeader--side-padding',
          topPadding && 'PageHeader--top-padding',
          showBorder && 'PageHeader--with-border',
        )}
      >
        {children}
      </header>
    )
  },
)

PageHeader.displayName = 'Page.Header'

export default PageHeader
